module.exports = __webpack_public_path__ + "img/symbol_s10.9ad381c.svg";